var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg036Calculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455,352c11.046,0,20-8.954,20-20V80c0-44.112-35.888-80-80-80H117C72.888,0,37,35.888,37,80v352 c0,44.112,35.888,80,80,80h278c44.112,0,80-35.888,80-80c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20 c0,22.056-17.944,40-40,40H117c-22.056,0-40-17.944-40-40V80c0-22.056,17.944-40,40-40h278c22.056,0,40,17.944,40,40v252 C435,343.046,443.954,352,455,352z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,392h-80c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h80c11.046,0,20-8.954,20-20 C395,400.954,386.046,392,375,392z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,240c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20s21.08-8.954,21.08-20C158.08,248.954,148.046,240,137,240z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217,
    cy: 260,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296,
    cy: 260,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,316c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20s21-8.954,21-20C158,324.954,148.046,316,137,316z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217,
    cy: 336,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296,
    cy: 336,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375,
    cy: 260,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 412,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375,
    cy: 336,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 412,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,80H137c-11.046,0-20,8.954-20,20v80c0,11.046,8.954,20,20,20h238c11.046,0,20-8.954,20-20v-80 C395,88.954,386.046,80,375,80z M355,160H157v-40h198V160z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg036Calculator);
export default __webpack_public_path__ + "static/media/036-calculator.6a32dcf538fa68afb4bc1872fbdc9276.svg";
export { ForwardRef as ReactComponent };